<template>
	<div class="tab-box">
		<div class="tab">
			<div class="tab-item" @click="emotion">
				<img src="../assets/images/emotion_tab.png" alt="" v-show="selectTab!='emotion'">
				<img src="../assets/images/emotion_tab_ac.png" alt="" v-show="selectTab=='emotion'">
				<div :class="selectTab=='emotion' ? 'table-name-ac':'table-name'">情绪识别</div>
			</div>
			<div class="tab-item" @click="service">
				<img src="../assets/images/service_tab.png" alt="" v-show="selectTab!='service'">
				<img src="../assets/images/service_tab_ac.png" alt="" v-show="selectTab=='service'">
				<div :class="selectTab=='service' ? 'table-name-ac':'table-name'">服务</div>
			</div>
			<div class="tab-item" @click="my">
				<img src="../assets/images/my_tab.png" alt="" v-show="selectTab!='my'">
				<img src="../assets/images/my_tab_ac.png" alt="" v-show="selectTab=='my'">
				<div :class="selectTab=='my' ? 'table-name-ac':'table-name'">我的</div>
				<div v-if="$store.state.secretarylength>0||$store.state.emodate>0" class="info-dot"></div>
			</div>
		</div>
	</div>
</template>
<script setup>
	// import { store } from '../utils/store.js'
	export default {
		data() {
			return {
				selectTab: this.name,
				loginPhone: '',
				showDot: false
			};
		},
		props: {
			name: String,
			hasdot: String
		},
		// computed: {
		// 	newhasdot() {
		// 		// let secretarylength = localStorage.getItem('secretarylength')
		// 		if(store.secretarylength>0){
		// 			return true;
		// 		}
		// 		return false;
		// 	}
		// },
		updated() {
			// this.showdots()
			// let secretarylength = localStorage.getItem('secretarylength')
			console.log("====updated====secretarylength======");
			// console.log(secretarylength);
		},
		methods: {
			showdots() {
				let secretarylength = localStorage.getItem('secretarylength')
				if (secretarylength && secretarylength > 0) {
					this.showDot = true;
				} else {
					this.showDot = false;
				}
			},
			emotion() {
				this.$router.push({
					path: '/'
				})
				this.selectTab = 'emotion'
			},
			service() {
				this.$router.push({
					path: '/service'
				})
				this.selectTab = 'service'
			},
			my() {
				this.$router.push({
					path: '/my'
				})
				this.selectTab = 'my'
			},
		},
		created() {

			// this.showdots()
			// console.log("====created====secretarylength======");
			// console.log(secretarylength);
			let phone = localStorage.getItem('phone')
			this.loginPhone = phone
		},

	};
</script>
<style lang='less' scoped>
	.tab-box {
		height: 50px;
		position: fixed;
		width: 100%;
		bottom: 0px;
		left: 0px;
		z-index: 1000;
	}

	.tab {
		height: 50px;
		background-color: #fff;
		display: flex;
		justify-content: space-around;
	}

	@media (min-width: 768px) {

		/*0~768*/
		.tab {
			width: 400px;
			margin: 0 auto;
		}
	}

	.tab-item {
		position: relative;
		width: 33.3%;
	}

	.tab-item img {
		display: block;
		height: 24px;
		margin: 0 auto;
		margin-top: 5px;
	}

	.info-dot {
		width: 6px;
		height: 6px;
		background-color: red;
		position: absolute;
		top: 3px;
		left: 35%;
		border-radius: 50%;
	}

	.table-name {
		margin-top: 4px;
		height: 12px;
		line-height: 12px;
		font-size: 10px;
		font-weight: 400;
		color: #333;
		text-align: center;
	}

	.table-name-ac {
		margin-top: 4px;
		height: 12px;
		line-height: 12px;
		font-size: 10px;
		font-weight: 400;
		color: #01D6D6;
		text-align: center;
	}
</style>
